<template>
  <div id="newsdetails" style="background-color: white;">
    <div class="news-bd" style="min-height: 300px;">
      <div class="news-l 1" style="display: inline-block;">
        <!-- <img :src="info.img" class="news-l-img"> -->
        <div class="news-l-tit">
          <h2>{{info.title}}</h2>
          <p>时间：{{info.time}}</p>
        </div>
        <el-card shadow="never" class="box-border">
          <div v-html="info.content" class="content"></div>
        </el-card>
      </div>
      <div class="news-r">
        <div class="news-r-tit">最新文章</div>
        <ul class="news-r-bd">
          <li v-for="(item,index) in latest" :key="index" @click="toDetail(index)" :class="{activenew:index1==index}">
            <img src="../assets/img/right-nav.png"><span>{{item.title}}</span>
          </li>
        </ul>
      </div>
      <div class="clear"></div>
      <div class="up_dow">
        <p v-if="i-1>=0" @click="toDetail(i-1)">上一条:&nbsp;&nbsp;{{list[i-1].title}}</p>
        <p v-if="i+1<=max" @click="toDetail(i+1)">下一条:&nbsp;&nbsp;{{list[i+1].title}}</p>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "Newsdetails",
  components: {
  },
  data(){
    return{
      info:{},
      list:[],
      latest:[],
      i:"",
      max:"",
			index1:sessionStorage.getItem("activenewsindex"),
    }
  },
  mounted: function() {
    let that = this;
    that.list = JSON.parse(sessionStorage.getItem("news"));
    that.max = that.list.length-1;
    that.i = Number(sessionStorage.getItem("activenewsindex"));
    that.info = that.list[that.i];
    if(that.max>=4){
      that.latest = that.list.slice(0,5);
    }else{
      that.latest = that.list.slice(0,that.max+1);
    }
  },
  methods: {
    toDetail(i){
      sessionStorage.setItem("activenewsindex", i);
      this.i = Number(sessionStorage.getItem("activenewsindex"));
      this.info = this.list[this.i];
			this.index1 = i;
    }
  }
};
</script>
<style scoped>
@import url("./../assets/css/aboutus.css");
@import url("./../assets/css/news.css");
.news-r-bd{
  font-size: 14px;
}
.news-r-bd li img{
  float: left;
  margin-top: 10px
}
.news-r-bd li span{
  width: calc(100% - 15px);
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.box-border {
    border: solid;
    border-width: thin;
    border-color: #95959587;
  }
.content >>> img{
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/components/newsdetails.vue